module.exports = __webpack_public_path__ + "img/edits-not-savings.3e5e2973.svg";